<template>
    <section>
        <form-wizard :startIndex="0" color="#0074D9" stepSize="xs" ref="wizard" :title="''" :subtitle="''"
            shape="circle">
            <tab-content v-if="modulo" title="Recurso Indisponível" icon="fa fa-frown-o">
                <div class="alert bg-orange alert-dismissible">
                    <p><strong><i class="icon fa fa-warning"></i> Seu plano não contempla o recurso solicitado
                        </strong></p>
                    <p>Selecione um plano superior para adquirir o conteúdo.</p>
                </div>
                <div class="col-md-12">
                    <div>
                        <h4><i class="fa fa-info-circle"></i> Para dúvidas, entre em contato com o suporte.</h4>
                        <p>Telefone: (12) 3152-9360 e (12) 9 7404-9319 <i class="text-green fa fa-whatsapp"></i></p>
                        <p>E-mail: suporte@mbd.com.br</p>
                        <p><i class="text-aqua fa fa-skype"></i> Skype: suporte@mbd.com.br</p>
                    </div>
                </div>
            </tab-content>
            <tab-content title="Empresa" icon="fa fa-building" v-if="!empresaLogada.municipio">
                <register-company :dados="dados"></register-company>
            </tab-content>
            <tab-content title="Selecionar Plano" icon="fa fa-tag">
                <table-plano :modulo="modulo" @choicePlan="choicePlan"></table-plano>
            </tab-content>
            <tab-content title="Assinatura" icon="fa fa-calendar">
                <register-asign :dados="dados" :selectedPlano="selectedPlano" @selectRecorrencia="selectRecorrencia">
                </register-asign>
            </tab-content>
            <tab-content title="Adicionais" icon="fa fa-plus">
                <register-plus :dados="dados" />
            </tab-content>
            <tab-content title="Pagamento" icon="fa fa-check">
                <div class="row">
                    <div class="col-md-8">
                        <card-form ref="TabPayment" :payment="dados.selected" />
                    </div>
                    <div class="col-md-4">
                        <register-store :dados="dados" :selectedPlano="selectedPlano" />
                    </div>
                </div>
            </tab-content>
            <button type="button" class="btn-wizard btn btn-primary" slot="prev"> VOLTAR </button>
            <button type="button" class="btn-wizard btn btn-primary" slot="next"> PROXIMO
                <i v-show="dados.loading" @click="send" class="fa fa-circle-o-notch fa-spin"></i>
            </button>
            <button @click="send" type="button" :disabled="dados.loading" class="btn-wizard btn btn-success"
                slot="finish">
                <i class="fa fa-check"></i>
                CONFIRMAR
                <i v-show="dados.loading" class="fa fa-circle-o-notch fa-spin"></i>
            </button>
        </form-wizard>
    </section>
</template>

<script>
    import {
        FormWizard,
        TabContent
    } from "vue-form-wizard";
    import TablePlano from '../home/components/table-plano.vue';
    import RegisterStore from '../home/components/register-store.vue';
    import RegisterCompany from '../home/components/register-company.vue';
    import RegisterAsign from '../home/components/register-asign.vue';
    import RegisterPlus from '../home/components/register-plus.vue';
    import CardForm from '../home/components/card-form.vue';
    export default {
        name: 'upgrade',
        components: {
            FormWizard,
            TabContent,
            TablePlano,
            RegisterPlus,
            RegisterAsign,
            CardForm,
            RegisterStore,
            RegisterCompany
        },
        data() {
            return {
                modulo: null,
                dados: {
                    adicionais: [],
                    loaded: true,
                    loading: false,
                    request: {},
                    settings: {
                        dots: true,
                        infinite: true,
                        speed: 500,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        initialSlide: 0,
                        centerPadding: "20px",
                        responsive: [{
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 3,
                                    infinite: true,
                                    dots: true,
                                },
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                    initialSlide: 2,
                                },
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                },
                            },
                        ],
                    },
                    selected: {
                        fk_plano_id: null,
                        fk_validade_id: "",
                        planoValor: 0,
                        cardName: "",
                        cardNumber: "",
                        cardMonth: null,
                        cardYear: null,
                        cardCvv: "",
                        grecaptcha: "",
                        documento: "",
                        fantasia: "",
                        cep: "",
                        endereco: "",
                        numero: "",
                        bairro: "",
                        cidade: null,
                        estado: null,
                        pais: "1058",
                        complemento: "",
                        adicionais: [],
                    },
                },
            };
        },
        computed: {
            selectedPlano() {
                return this.$store.state.plano.selectedPlano;
            },
        },
        watch: {
            $route(data) {
                if (data.name != 'upgrade')
                    this.$destroy();
            },
        },
        mounted() {
            this.dados.selected.fantasia = this.empresaLogada.emp_razao;
        },
        beforeMount() {
            this.dados.selected.fantasia = this.empresaLogada.emp_razao;
            this.modulo = this.$route.params.modulo;
        },
        methods: {
            validatePayment() {
                return this.$refs.TabPayment.validate();
            },
            selectRecorrencia(payload) {
                if (this.$refs.wizard) {
                    //this.$refs.wizard.changeTab(1, 2);
                }
            },
            choicePlan(payload) {
                this.$store.commit('SET_PLANO_SELECTED', payload);
            },
            async send() {
                let valid = await this.validatePayment();
                if (!valid) {
                    return
                }
                this.dados.selected.fk_plano_id = this.selectedPlano.id;
                if (!this.dados.selected.fk_plano_id) {
                    toastr({
                        icon: 'error',
                        title: 'Escolha um plano!'
                    });
                    this.$refs.wizard.changeTab(3, 0);
                    return;
                }
                if (!this.dados.selected.fk_validade_id) {
                    toastr({
                        icon: 'error',
                        title: 'Escolha uma assinatura!'
                    });
                    this.$refs.wizard.changeTab(3, 0);
                    return;
                }
                this.dados.selected.grecaptcha = await this.$recaptcha("CadastroOffice").then(token => {
                    return token;
                });
                this.dados.selected.tokenId = this.$route.params.tokenId;
                this.dados.loading = true;

                this.$store.dispatch('reativarDocx', this.dados.selected).then(response => {
                    console.log(response);
                    this.dados.loading = false;
                    toastr({
                        title: response.message,
                        icon: response.status,
                    });
                    if (response.status != 'success') return
                    this.$store.dispatch('getUserData');
                    this.$router.push('/');
                })
            },
        }
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .errPage-container {
        width: 800px;
        margin: 50px auto;

        .pan-back-btn {
            background: #008489;
            color: #fff;
            border: none !important;
        }

        .pan-gif {
            margin: 0 auto;
            display: block;
        }

        .pan-img {
            display: block;
            margin: 0 auto;
            width: 100%;
        }

        .text-jumbo {
            font-size: 60px;
            font-weight: 700;
            color: #484848;
        }

        .list-unstyled {
            font-size: 14px;

            li {
                padding-bottom: 5px;
            }
        }
    }
</style>